import TemplateView from '../../../../TemplateView'
import BulkInvitationsItem, {Type} from './BulkInvitationsItem'

export default class BulkInvitationsDropdown extends TemplateView {
    constructor({
        manualInvitationsClick = () => {},
        csvImportClick = () => {},
    }) {
        super()
        this.manualInvitationsClick = manualInvitationsClick
        this.csvImportClick = csvImportClick
    }

    templateHtml() {
        return "<div></div>"
    }

    afterRender() {
        new BulkInvitationsItem({
            type: Type.MANUAL,
            additionalClass: 'option',
            onClick: this.manualInvitationsClick
        }).init(this.$el)

        new BulkInvitationsItem({
            type: Type.CSV_IMPORT,
            additionalClass: 'option',
            onClick: this.csvImportClick
        }).init(this.$el)
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/components/managementButtons/BulkInvitationsDropdown.js